module.exports = __webpack_public_path__ + "media/images/logo-fb-simple-8431953f58c6b16d79fd97fc0c999041.svg";